import Vue from 'vue'
import Router from 'vue-router'
import ResearchInfo from '@/components/ResearchInfo'
import PersonnelInfo from '@/components/PersonnelInfo'
import Home from '@/components/Home'

Vue.use(Router)

export default new Router({
  // base: 'research',
  mode: 'history',
  routes: [
    { path: '*', redirect: '/info' },
    {
      path: '/info',
      name: 'Home',
      component: Home
    },
    {
      path: '/info/personnel',
      name: 'PersonnelInfo',
      component: PersonnelInfo
    },
    {
      path: '/info/personnel/:i?-:name?',
      name: 'PersonnelInfoDetail',
      component: PersonnelInfo
    },
    {
      path: '/info/:faculty?/:year?',
      name: 'ResearchInfo',
      component: ResearchInfo
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js